import {getPosterUi} from '@PosterWhiteboard/ui/poster-ui';
import {isTimelineModeOn} from '@PosterWhiteboard/libraries/timeline-mode.library';

export const isPageNavigationBlocked = (): boolean => {
  if (isTimelineModeOn()) {
    return true;
  }

  return getPosterUi().isPageNavigationBlockedByModal();
};
